import { createSlice } from "@reduxjs/toolkit";
import {
  getSignupFieldsDropdownRepo, getipinfoLocationRepo,
  postSignupRepo, getTertiaryCheckboxRepo
} from "../../repositories/Registration/index";

const SignUpFieldsSlice = createSlice({
  name: "signUpFieldsReducer",
  initialState: {
    educationLevelFieldLoading: false,
    education_level: null,
    educationLevelFieldError: null,
    ipinfoLocationLoading: false,
    ipinfoLocation: null,
    ipinfoLocationError: null,
    locationFieldLoading: false,
    locationField: null,
    locationFieldError: null,
    passingYearLoading: false,
    passing_year: null,
    passingYearError: null,
    schoolBoardLoading: false,
    school_board: null,
    schoolBoardError: null,
    aspiringStreamLoading: false,
    aspiring_stream: null,
    aspiringStreamError: null,
    educationInterestLoading: false,
    education_interest: null,
    educationInterestError: null,
    degreePursuingLoading: false,
    degree_pursue: null,
    degreePursuingError: null,
    interestedInLoading: false,
    interested_in: null,
    interestedInEror: null,
    areaOfInterestLoading: false,
    area_of_interest: null,
    areaOfInterestError: null,
    courseJoningPreferenceLoading: false,
    course_joining_preference: null,
    courseJoningPreferenceError: null,
    workExperienceLoading: false,
    work_experience: null,
    workExperienceError: null,
    countryLoading: false,
    country: null,
    countryError: null,
    targetYearLoading: false,
    target_year: null,
    targetYearError: null,
    signupDataLoading: false,
    signupData: null,
    signupDataError: null,
    tertiaryChecboxLoading: false,
    tertiaryChecbox: null,
    tertiaryChecboxError: null,
    certificateInterestLoading: false,
    certificate_interest: null,
    certificateInterestError: null,
    secondaryDomainLoading: false,
    secondaryDomain: null,
    secondaryDomainError: null
  },
  reducers: {
    getEducationLevelFieldLoading(state, action) {
      return {
        ...state,
        educationLevelFieldLoading: true,
      };
    },
    getEducationLevelFieldSuccess(state, action) {
      return {
        ...state,
        educationLevelFieldLoading: false,
        education_level: action.payload,
      };
    },
    getEducationLevelFieldFailure(state, action) {
      return {
        ...state,
        educationLevelFieldLoading: false,
        educationLevelFieldError: action.payload,
      };
    },
    clearEducationLevelFieldResponse(state, action) {
      return {
        ...state,
        education_level: null,
      };
    },
    getipinfoLocationLoading(state, action) {
      return {
        ...state,
        ipinfoLocationLoading: true,
      };
    },
    getipinfoLocationSuccess(state, action) {
      return {
        ...state,
        ipinfoLocationLoading: false,
        ipinfoLocation: action.payload,
      };
    },
    getipinfoLocationFailure(state, action) {
      return {
        ...state,
        ipinfoLocationLoading: false,
        ipinfoLocationError: action.payload,
      };
    },
    getLocationFieldLoading(state, action) {
      return {
        ...state,
        locationFieldLoading: true,
      };
    },
    getLocationFieldSuccess(state, action) {
      return {
        ...state,
        locationFieldLoading: false,
        locationField: action.payload,
      };
    },
    getLocationFieldFailure(state, action) {
      return {
        ...state,
        locationFieldLoading: false,
        locationFieldError: action.payload,
      };
    },
    clearLocationFieldResponse(state, action) {
      return {
        ...state,
        locationField: null,
      };
    },
    getPassingYearFieldLoading(state, action) {
      return {
        ...state,
        passingYearLoading: true,
      };
    },
    getPassingYearFieldSuccess(state, action) {
      return {
        ...state,
        passingYearLoading: false,
        passing_year: action.payload,
      };
    },
    getPassingYearFieldFailure(state, action) {
      return {
        ...state,
        passingYearLoading: false,
        passingYearError: action.payload,
      };
    },
    clearPassingYearFieldResponse(state, action) {
      return {
        ...state,
        passing_year: null,
      };
    },
    getSchoolBoardLoading(state, action) {
      return {
        ...state,
        schoolBoardLoading: true,
      };
    },
    getSchoolBoardSuccess(state, action) {
      return {
        ...state,
        schoolBoardLoading: false,
        school_board: action.payload,
      };
    },
    getSchoolBoardFailure(state, action) {
      return {
        ...state,
        schoolBoardLoading: false,
        schoolBoardError: action.payload,
      };
    },
    getAspiringStreamFieldLoading(state, action) {
      return {
        ...state,
        aspiringStreamLoading: true,
      };
    },
    getAspiringStreamFieldSuccess(state, action) {
      return {
        ...state,
        aspiringStreamLoading: false,
        aspiring_stream: action.payload,
      };
    },
    getAspiringStreamFieldFailure(state, action) {
      return {
        ...state,
        aspiringStreamLoading: false,
        aspiringStreamError: action.payload,
      };
    },
    clearAspiringStreamFieldResponse(state, action) {
      return {
        ...state,
        aspiring_stream: null,
      };
    },
    getEducationInterestFieldLoading(state, action) {
      return {
        ...state,
        educationInterestLoading: true,
      };
    },
    getEducationInterestFieldSuccess(state, action) {
      return {
        ...state,
        educationInterestLoading: false,
        education_interest: action.payload,
      };
    },
    getEducationInterestFieldFailure(state, action) {
      return {
        ...state,
        educationInterestLoading: false,
        educationInterestError: action.payload,
      };
    },
    clearEducationInterestFieldResponse(state, action) {
      return {
        ...state,
        education_interest: null,
      };
    },
    getDegreePursuingFieldLoading(state, action) {
      return {
        ...state,
        degreePursuingLoading: true,
      };
    },
    getDegreePursuingFieldSuccess(state, action) {
      return {
        ...state,
        degreePursuingLoading: false,
        degree_pursue: action.payload,
      };
    },
    getDegreePursuingFieldFailure(state, action) {
      return {
        ...state,
        degreePursuingLoading: false,
        degreePursuingError: action.payload,
      };
    },
    clearDegreePursuingFieldResponse(state, action) {
      return {
        ...state,
        degree_pursue: null,
      };
    },
    getInterestedInFieldLoading(state, action) {
      return {
        ...state,
        interestedInLoading: true,
      };
    },
    getInterestedInFieldSuccess(state, action) {
      return {
        ...state,
        interestedInLoading: false,
        interested_in: action.payload,
      };
    },
    getInterestedInFieldFailure(state, action) {
      return {
        ...state,
        interestedInLoading: false,
        interestedInError: action.payload,
      };
    },
    clearInterestedInFieldResponse(state, action) {
      return {
        ...state,
        interested_in: null,
      };
    },
    getAreaOfInterestFieldLoading(state, action) {
      return {
        ...state,
        areaOfInterestLoading: true,
      };
    },
    getAreaOfInterestFieldSuccess(state, action) {
      return {
        ...state,
        areaOfInterestLoading: false,
        area_of_interest: action.payload,
      };
    },
    getAreaOfInterestFieldFailure(state, action) {
      return {
        ...state,
        areaOfInterestLoading: false,
        areaOfInterestError: action.payload,
      };
    },
    clearAreaOfInterestFieldResponse(state, action) {
      return {
        ...state,
        area_of_interest: null,
      };
    },
    getCourseJoinPreferenceFieldLoading(state, action) {
      return {
        ...state,
        CourseJoinPreferenceLoading: true,
      };
    },
    getCourseJoinPreferenceFieldSuccess(state, action) {
      return {
        ...state,
        CourseJoinPreferenceLoading: false,
        course_joining_preference: action.payload,
      };
    },
    getCourseJoinPreferenceFieldFailure(state, action) {
      return {
        ...state,
        CourseJoinPreferenceLoading: false,
        CourseJoinPreferenceError: action.payload,
      };
    },
    clearCourseJoinPreferenceFieldResponse(state, action) {
      return {
        ...state,
        course_joining_preference: null,
      };
    },
    getWorkExperienceFieldLoading(state, action) {
      return {
        ...state,
        workExperienceLoading: true,
      };
    },
    getWorkExperienceFieldSuccess(state, action) {
      return {
        ...state,
        workExperienceLoading: false,
        work_experience: action.payload,
      };
    },
    getWorkExperienceFieldFailure(state, action) {
      return {
        ...state,
        workExperienceLoading: false,
        workExperienceError: action.payload,
      };
    },
    clearWorkExperienceFieldResponse(state, action) {
      return {
        ...state,
        work_experience: null,
      };
    },
    getTargetedCountriesFieldLoading(state, action) {
      return {
        ...state,
        countryLoading: true,
      };
    },
    getTargetedCountriesFieldSuccess(state, action) {
      return {
        ...state,
        countryLoading: false,
        country: action.payload,
      };
    },
    getTargetedCountriesFieldFailure(state, action) {
      return {
        ...state,
        countryLoading: false,
        countryError: action.payload,
      };
    },
    clearTargetedCountriesFieldResponse(state, action) {
      return {
        ...state,
        country: null,
      };
    },
    getTargetYearFieldLoading(state, action) {
      return {
        ...state,
        targetYearLoading: true,
      };
    },
    getTargetYearFieldSuccess(state, action) {
      return {
        ...state,
        targetYearLoading: false,
        target_year: action.payload,
      };
    },
    getTargetYearFieldFailure(state, action) {
      return {
        ...state,
        targetYearLoading: false,
        targetYearError: action.payload,
      };
    },
    clearTargetYearFieldResponse(state, action) {
      return {
        ...state,
        target_year: null,
      };
    },
    postSignupDataLoading(state, action) {
      return {
        ...state,
        signupDataLoading: true,
        signupData: null,
        signupDataError: null
      };
    },
    postSignupDataSuccess(state, action) {
      return {
        ...state,
        signupDataLoading: false,
        signupData: action.payload,
      };
    },
    postSignupDataFailure(state, action) {
      return {
        ...state,
        signupDataLoading: false,
        signupDataError: action.payload,
      };
    },
    clearSignupDataResponse(state, action) {
      return {
        ...state,
        signupData: null,
        signupDataError: null
      };
    },
    getTertiaryCheckboxLoading(state, action) {
      return {
        ...state,
        tertiaryChecboxLoading: true,
        tertiaryChecboxError: null
      };
    },
    getTertiaryCheckboxSuccess(state, action) {
      return {
        ...state,
        tertiaryChecboxLoading: false,
        tertiaryChecbox: action.payload,
        tertiaryChecboxError: null
      };
    },
    getTertiaryCheckboxFailure(state, action) {
      return {
        ...state,
        tertiaryChecboxLoading: false,
        tertiaryChecboxError: action.payload,
        tertiaryChecbox: null
      };
    },
    clearTertiaryCheckboxResponse(state, action) {
      return {
        ...state,
        tertiaryChecboxLoading: false,
        tertiaryChecbox: null
      };
    },
    getCertificateInterestFieldLoading(state, action) {
      return {
        ...state,
        certificateInterestLoading: true,
      };
    },
    getCertificateInterestFieldSuccess(state, action) {
      return {
        ...state,
        certificateInterestLoading: false,
        certificate_interest: action.payload,
      };
    },
    getCertificateInterestFieldFailure(state, action) {
      return {
        ...state,
        certificateInterestLoading: false,
        certificateInterestError: action.payload,
      };
    },
    clearCertificateInterestFieldResponse(state, action) {
      return {
        ...state,
        certificate_interest: null,
      };
    },
    getSecondaryDomainLoading(state, action) {
      return {
        ...state,
        secondaryDomainLoading: true,
      };
    },
    getSecondaryDomainSuccess(state, action) {
      return {
        ...state,
        secondaryDomainLoading: false,
        secondaryDomain: action.payload,
      };
    },
    getSecondaryDomainFailure(state, action) {
      return {
        ...state,
        secondaryDomainLoading: false,
        secondaryDomainError: action.payload,
      };
    },
    clearSecondaryDomainResponse(state, action) {
      return {
        ...state,
        secondaryDomain: null,
      };
    },
  },
});

export const {
  getEducationLevelFieldLoading,
  getEducationLevelFieldSuccess,
  getEducationLevelFieldFailure,
  clearEducationLevelFieldResponse,
  getipinfoLocationLoading,
  getipinfoLocationSuccess,
  getipinfoLocationFailure,
  getLocationFieldLoading,
  getLocationFieldSuccess,
  getLocationFieldFailure,
  clearLocationFieldResponse,
  getPassingYearFieldLoading,
  getPassingYearFieldSuccess,
  getPassingYearFieldFailure,
  getSchoolBoardLoading,
  getSchoolBoardSuccess,
  getSchoolBoardFailure,
  clearPassingYearFieldResponse,
  getAspiringStreamFieldLoading,
  getAspiringStreamFieldSuccess,
  getAspiringStreamFieldFailure,
  clearAspiringStreamFieldResponse,
  getEducationInterestFieldLoading,
  getEducationInterestFieldSuccess,
  getEducationInterestFieldFailure,
  clearEducationInterestFieldResponse,
  getDegreePursuingFieldLoading,
  getDegreePursuingFieldSuccess,
  getDegreePursuingFieldFailure,
  clearDegreePursuingFieldResponse,
  getInterestedInFieldLoading,
  getInterestedInFieldSuccess,
  getInterestedInFieldFailure,
  clearInterestedInFieldResponse,
  getAreaOfInterestFieldLoading,
  getAreaOfInterestFieldSuccess,
  getAreaOfInterestFieldFailure,
  clearAreaOfInterestFieldResponse,
  getCourseJoinPreferenceFieldLoading,
  getCourseJoinPreferenceFieldSuccess,
  getCourseJoinPreferenceFieldFailure,
  clearCourseJoinPreferenceFieldResponse,
  getWorkExperienceFieldLoading,
  getWorkExperienceFieldSuccess,
  getWorkExperienceFieldFailure,
  clearWorkExperienceFieldResponse,
  getTargetedCountriesFieldLoading,
  getTargetedCountriesFieldSuccess,
  getTargetedCountriesFieldFailure,
  clearTargetedCountriesFieldResponse,
  getTargetYearFieldLoading,
  getTargetYearFieldSuccess,
  getTargetYearFieldFailure,
  clearTargetYearFieldResponse,
  postSignupDataLoading,
  postSignupDataSuccess,
  postSignupDataFailure,
  clearSignupDataResponse,
  getTertiaryCheckboxLoading,
  getTertiaryCheckboxSuccess,
  getTertiaryCheckboxFailure,
  clearTertiaryCheckboxResponse,
  getCertificateInterestFieldLoading,
  getCertificateInterestFieldSuccess,
  getCertificateInterestFieldFailure,
  clearCertificateInterestFieldResponse,
  getSecondaryDomainLoading,
  getSecondaryDomainSuccess,
  getSecondaryDomainFailure,
  clearSecondaryDomainResponse
} = SignUpFieldsSlice.actions;

export const getEducationLevelField = (params) => {
  return (dispatch) => {
    dispatch(getEducationLevelFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getEducationLevelFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getEducationLevelFieldFailure(error.message));
        }
      });
  };
};

export const getipinfoLocation = (params) => {
  return (dispatch) => {
    dispatch(getipinfoLocationLoading());
    getipinfoLocationRepo(params)
      .then((response) => {
        if (response.status == 200) {
          dispatch(getipinfoLocationSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getipinfoLocationFailure(error.message));
        }
      });
  };
};


export const getLocationField = (params) => {
  return (dispatch) => {
    dispatch(getLocationFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getLocationFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getLocationFieldFailure(error.message));
        }
      });
  };
};

export const getPassingYearField = (params) => {
  return (dispatch) => {
    dispatch(getPassingYearFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getPassingYearFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getPassingYearFieldFailure(error.message));
        }
      });
  };
};

export const getSchoolBoardField = (params) => {
  return (dispatch) => {
    dispatch(getSchoolBoardLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getSchoolBoardSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getSchoolBoardFailure(error.message));
        }
      });
  };
};

export const getAspiringStreamField = (params) => {
  return (dispatch) => {
    dispatch(getAspiringStreamFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getAspiringStreamFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getAspiringStreamFieldFailure(error.message));
        }
      });
  };
};

export const getEducationInterestField = (params) => {
  return (dispatch) => {
    dispatch(getEducationInterestFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getEducationInterestFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getEducationInterestFieldFailure(error.message));
        }
      });
  };
};

export const getDegreePursuingField = (params) => {
  return (dispatch) => {
    dispatch(getDegreePursuingFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getDegreePursuingFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getDegreePursuingFieldFailure(error.message));
        }
      });
  };
};

export const getInterestedInField = (params) => {
  return (dispatch) => {
    dispatch(getInterestedInFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getInterestedInFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getInterestedInFieldFailure(error.message));
        }
      });
  };
};

export const getAreaOfInterestField = (params) => {
  return (dispatch) => {
    dispatch(getAreaOfInterestFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getAreaOfInterestFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getAreaOfInterestFieldFailure(error.message));
        }
      });
  };
};

export const getCourseJoinPreferenceField = (params) => {
  return (dispatch) => {
    dispatch(getCourseJoinPreferenceFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getCourseJoinPreferenceFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCourseJoinPreferenceFieldFailure(error.message));
        }
      });
  };
};

export const getWorkExperienceField = (params) => {
  return (dispatch) => {
    dispatch(getWorkExperienceFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getWorkExperienceFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getWorkExperienceFieldFailure(error.message));
        }
      });
  };
};

export const getTargetedCountriesField = (params) => {
  return (dispatch) => {
    dispatch(getTargetedCountriesFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getTargetedCountriesFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getTargetedCountriesFieldFailure(error.message));
        }
      });
  };
};

export const getTargetYearField = (params = {}) => {
  return (dispatch) => {
    dispatch(getTargetYearFieldLoading());
    let updatedParams = { ...params };
    if (!updatedParams.domain_id) {

      const upSessionDomainId = sessionStorage.getItem("up_domain_id");
      if (upSessionDomainId) {
        updatedParams.domain_id = parseInt(upSessionDomainId);
      }
      const sessionDomainId = sessionStorage.getItem("domain_id");
      if (sessionDomainId && !upSessionDomainId) {
        updatedParams.domain_id = parseInt(sessionDomainId);
      }
    }

    getSignupFieldsDropdownRepo(updatedParams)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getTargetYearFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getTargetYearFieldFailure(error.message));
        }
      });
  };
};

export const postSignUpData = (data) => {
  return (dispatch) => {
    dispatch(postSignupDataLoading());
    postSignupRepo(data)
      .then((response) => {
        if (
          response.status === 302 ||
          response.status === 200 ||
          response.status === 201
        ) {
          dispatch(postSignupDataSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postSignupDataFailure(error?.response?.data?.data));
        }else if (error){
          dispatch(postSignupDataFailure(error?.message));
        }
      });
  };
};

export const getTertiaryCheckboxData = (params) => {
  return (dispatch) => {
    dispatch(getTertiaryCheckboxLoading());
    getTertiaryCheckboxRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getTertiaryCheckboxSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getTertiaryCheckboxFailure(error.message));
        }
      });
  };
};

export const getCertificateInterestFieldData = (params) => {
  return (dispatch) => {
    dispatch(getCertificateInterestFieldLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getCertificateInterestFieldSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCertificateInterestFieldFailure(error.message));
        }
      });
  };
};

export const getSecondaryDomainData = (params) => {
  return (dispatch) => {
    dispatch(getSecondaryDomainLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getSecondaryDomainSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getSecondaryDomainFailure(error.message));
        }
      });
  };
};

export default SignUpFieldsSlice.reducer;
